export default {
  'leaderboard.title': '🏆 Bảng xếp hạng Referral',
  'leaderboard.subtitle': 'Top người giới thiệu nhiều nhất',
  'leaderboard.headerTitle': 'Bảng xếp hạng',
  'leaderboard.rank': 'Xếp hạng',
  'leaderboard.walletAddress': 'Địa chỉ ví',
  'leaderboard.totalReferrals': 'Tổng Referrals',
  'leaderboard.telegram': 'Telegram',
  'leaderboard.referralCode': 'Mã giới thiệu',
  'leaderboard.survey': 'Khảo sát',
  'leaderboard.status': 'Trạng thái',
  'leaderboard.createdAt': 'Ngày tạo',
  'leaderboard.from': 'Từ ngày',
  'leaderboard.to': 'Đến ngày',
  'leaderboard.copySuccess': 'Đã sao chép vào clipboard!',
  'leaderboard.notLinked': 'Chưa liên kết',
  'leaderboard.viewDetail': 'Xem chi tiết',
  'leaderboard.verified': 'Đã xác thực',
  'leaderboard.placeholder.telegram': 'Tìm theo username, tên hoặc email (X, Tele, Gmail)',
  'leaderboard.placeholder.code': 'Nhập mã giới thiệu',
  'leaderboard.survey.done': 'Đã làm',
  'leaderboard.survey.notDone': 'Chưa làm',
  'leaderboard.status.verified': 'Đã verify',
  'leaderboard.status.notVerified': 'Chưa verify',
  'leaderboard.totalCount': 'Tổng {total} người',
  'leaderboard.referrals.new': 'Mới: {count} referrals',
  'leaderboard.referrals.old': 'Cũ: {count} referrals',
};
